import * as React from 'react';
import { Error as ErrorComponent } from '../components/Error';
import { Login as LoginComponent } from '../components/Login';
import { Maintenance as MaintenanceComponent } from '../components/Maintenance';
import { NotFound as NotFoundComponent } from '../components/NotFound';
import { Timeout as TimeoutComponent } from '../components/Timeout';
import { staticComponent } from './Static';
export const Error = staticComponent(ErrorComponent);
export const Login = staticComponent(LoginComponent);
export const Maintenance = staticComponent(MaintenanceComponent);
export const NotFound = staticComponent(NotFoundComponent);
export const Timeout = staticComponent(TimeoutComponent);